import ProductView_Compo from "../features/ProductView/ProductView_Compo"
function ProductViewPage() {
    return (
        <ProductView_Compo />
    );
}

export default ProductViewPage;